import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const MDeRCMDentalComponent = () => {
  // Custom SVG Icons as components
  const ChevronDown = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <polyline points="6,9 12,15 18,9"></polyline>
    </svg>
  );

  const ChevronRight = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <polyline points="9,18 15,12 9,6"></polyline>
    </svg>
  );

  const AlertTriangle = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"/>
      <line x1="12" y1="9" x2="12" y2="13"/>
      <line x1="12" y1="17" x2="12.01" y2="17"/>
    </svg>
  );

  const CheckCircle = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
      <polyline points="22,4 12,14.01 9,11.01"/>
    </svg>
  );

  const Brain = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z"/>
      <path d="M12 5a3 3 0 1 1 5.997.125 4 4 0 0 1 2.526 5.77 4 4 0 0 1-.556 6.588A4 4 0 1 1 12 18Z"/>
      <path d="M15 13a4.5 4.5 0 0 1-3-4 4.5 4.5 0 0 1-3 4"/>
      <path d="M17.599 6.5a3 3 0 0 0 .399-1.375"/>
      <path d="M6.003 5.125A3 3 0 0 0 6.401 6.5"/>
      <path d="M3.477 10.896a4 4 0 0 1 .585-.396"/>
      <path d="M19.938 10.5a4 4 0 0 1 .585.396"/>
      <path d="M6 18a4 4 0 0 1-1.967-.516"/>
      <path d="M19.967 17.484A4 4 0 0 1 18 18"/>
    </svg>
  );

  const Target = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <circle cx="12" cy="12" r="10"/>
      <circle cx="12" cy="12" r="6"/>
      <circle cx="12" cy="12" r="2"/>
    </svg>
  );

  const DollarSign = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <line x1="12" y1="1" x2="12" y2="23"/>
      <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
    </svg>
  );

  const Zap = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <polygon points="13,2 3,14 12,14 11,22 21,10 12,10 13,2"/>
    </svg>
  );

  const [activeTab, setActiveTab] = useState('problems');
  const [expandedProblem, setExpandedProblem] = useState(null);
  const [expandedSolution, setExpandedSolution] = useState(null);

  // Styles
  const styles = {
    container: {
      minHeight: '100vh',
      background: 'linear-gradient(to bottom right, #dbeafe, #ffffff, #e0e7ff)',
      fontFamily: 'Arial, sans-serif'
    },
    header: {
      background: 'linear-gradient(to right, #2563eb, #4f46e5)',
      color: 'white',
      padding: '2rem 0'
    },
    headerContent: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '0 1.5rem',
      textAlign: 'center'
    },
    mainTitle: {
      fontSize: '2.5rem',
      fontWeight: 'bold',
      marginBottom: '0.5rem'
    },
    subtitle: {
      fontSize: '1.25rem',
      color: '#bfdbfe',
      marginBottom: '1rem'
    },
    description: {
      color: '#93c5fd',
      maxWidth: '48rem',
      margin: '0 auto 1rem',
      lineHeight: '1.6'
    },
    tabNavigation: {
      background: 'white',
      boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
      borderBottom: '1px solid #e5e7eb'
    },
    tabContainer: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '0 1.5rem',
      display: 'flex',
      justifyContent: 'center',
      gap: '2rem'
    },
    tabButton: (active) => ({
      padding: '1rem 0.5rem',
      borderBottom: active ? '2px solid #2563eb' : '2px solid transparent',
      color: active ? '#2563eb' : '#6b7280',
      fontWeight: '500',
      fontSize: '0.875rem',
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      transition: 'all 0.2s'
    }),
    mainContent: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '3rem 1.5rem'
    },
    sectionHeader: {
      textAlign: 'center',
      marginBottom: '3rem'
    },
    sectionTitle: {
      fontSize: '2rem',
      fontWeight: 'bold',
      color: '#111827',
      marginBottom: '1rem'
    },
    sectionSubtitle: {
      fontSize: '1.25rem',
      color: '#6b7280',
      maxWidth: '48rem',
      margin: '0 auto',
      lineHeight: '1.6'
    },
    problemsGrid: {
      display: 'grid',
      gap: '1.5rem',
      maxWidth: '64rem',
      margin: '0 auto'
    },
    solutionsGrid: {
      display: 'grid',
      gap: '2rem',
      maxWidth: '72rem',
      margin: '0 auto'
    },
    card: {
      background: 'white',
      borderRadius: '0.5rem',
      boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
      border: '1px solid #e5e7eb',
      overflow: 'hidden'
    },
    solutionCard: {
      background: 'white',
      borderRadius: '0.75rem',
      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
      border: '1px solid #e5e7eb',
      overflow: 'hidden',
      transition: 'box-shadow 0.3s'
    },
    cardHeader: {
      padding: '1.5rem',
      cursor: 'pointer',
      transition: 'background-color 0.2s'
    },
    cardHeaderHover: {
      backgroundColor: '#f9fafb'
    },
    cardContent: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    },
    cardLeft: {
      display: 'flex',
      alignItems: 'center',
      gap: '1rem'
    },
    iconContainer: (severity) => ({
      padding: '0.5rem',
      borderRadius: '0.5rem',
      backgroundColor: severity === 'high' ? '#fee2e2' : '#fef3c7'
    }),
    icon: (severity) => ({
      width: '1.25rem',
      height: '1.25rem',
      color: severity === 'high' ? '#dc2626' : '#d97706'
    }),
    cardInfo: {
      flex: 1
    },
    cardTitle: {
      fontSize: '1.25rem',
      fontWeight: '600',
      color: '#111827',
      marginBottom: '0.25rem'
    },
    cardDescription: {
      color: '#6b7280'
    },
    cardRight: {
      display: 'flex',
      alignItems: 'center',
      gap: '1rem'
    },
    impactBadge: (severity) => ({
      fontSize: '0.875rem',
      fontWeight: '500',
      padding: '0.25rem 0.75rem',
      borderRadius: '9999px',
      backgroundColor: severity === 'high' ? '#fee2e2' : '#fef3c7',
      color: severity === 'high' ? '#dc2626' : '#d97706'
    }),
    chevronContainer: {
      color: '#9ca3af'
    },
    expandedContent: {
      borderTop: '1px solid #e5e7eb',
      backgroundColor: '#f9fafb'
    },
    expandedContentInner: {
      padding: '1.5rem'
    },
    expandedTitle: {
      fontSize: '1rem',
      fontWeight: '600',
      color: '#374151',
      marginBottom: '1rem'
    },
    detailsList: {
      listStyle: 'none',
      padding: 0,
      margin: 0,
      display: 'flex',
      flexDirection: 'column',
      gap: '0.75rem'
    },
    detailItem: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: '0.75rem'
    },
    detailBullet: {
      width: '0.375rem',
      height: '0.375rem',
      borderRadius: '50%',
      backgroundColor: '#3b82f6',
      flexShrink: 0,
      marginTop: '0.5rem'
    },
    detailText: {
      fontSize: '0.875rem',
      color: '#6b7280',
      lineHeight: '1.5'
    },
    solutionCardHeader: {
      padding: '1.5rem',
      cursor: 'pointer'
    },
    solutionCardContent: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '1rem'
    },
    solutionLeft: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: '1rem',
      flex: 1
    },
    solutionIconContainer: {
      padding: '0.75rem',
      borderRadius: '0.5rem',
      backgroundColor: '#dbeafe'
    },
    solutionIcon: {
      width: '1.5rem',
      height: '1.5rem',
      color: '#2563eb'
    },
    solutionInfo: {
      flex: 1
    },
    solutionTitle: {
      fontSize: '1.25rem',
      fontWeight: '600',
      color: '#111827',
      marginBottom: '0.5rem'
    },
    solutionDescription: {
      fontSize: '0.875rem',
      color: '#6b7280',
      marginBottom: '0.75rem',
      lineHeight: '1.5'
    },
    benefitsContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '0.5rem'
    },
    benefitBadge: {
      fontSize: '0.75rem',
      fontWeight: '500',
      padding: '0.25rem 0.75rem',
      borderRadius: '9999px',
      backgroundColor: '#dcfce7',
      color: '#166534'
    },
    solutionExpandedContent: {
      borderTop: '1px solid #e5e7eb',
      backgroundColor: '#f9fafb'
    },
    solutionExpandedInner: {
      padding: '1.5rem'
    },
    featuresTitle: {
      fontSize: '1rem',
      fontWeight: '600',
      color: '#374151',
      marginBottom: '1rem',
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem'
    },
    checkIcon: {
      width: '1.25rem',
      height: '1.25rem',
      color: '#10b981'
    },
    featuresGrid: {
      display: 'grid',
      gap: '0.75rem'
    },
    featureItem: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: '0.75rem'
    },
    featureBullet: {
      width: '0.375rem',
      height: '0.375rem',
      borderRadius: '50%',
      backgroundColor: '#10b981',
      flexShrink: 0,
      marginTop: '0.5rem'
    },
    featureText: {
      fontSize: '0.875rem',
      color: '#6b7280',
      lineHeight: '1.5'
    }
  };

  const dentalProblems = [
    {
      id: 1,
      title: "Insurance Verification Delays",
      description: "Manual verification creates bottlenecks and increases claim denials",
      severity: "high",
      impact: "High Revenue Impact",
      details: [
        "Average 15-20 minutes per patient for manual verification",
        "30-40% of claims denied due to eligibility issues",
        "Delayed treatment starts affecting patient satisfaction",
        "Staff burnout from repetitive verification tasks"
      ]
    },
    {
      id: 2,
      title: "Claims Processing Errors",
      description: "Manual coding and data entry lead to frequent rejections",
      severity: "high",
      impact: "High Revenue Loss",
      details: [
        "15-25% error rate in manual claims submission",
        "Average 45-60 day delay for corrected claims",
        "Lost revenue from write-offs and abandoned claims",
        "High cost of rework and resubmission"
      ]
    },
    {
      id: 3,
      title: "Slow Payment Collections",
      description: "Inefficient AR follow-up extends payment cycles",
      severity: "medium",
      impact: "Cash Flow Issues",
      details: [
        "Average 60-90 days for payment collection",
        "Inconsistent follow-up on aging accounts",
        "Limited visibility into payment status",
        "Manual reconciliation consuming staff hours"
      ]
    },
    {
      id: 4,
      title: "Patient Payment Friction",
      description: "Complex payment processes reduce collection rates",
      severity: "medium",
      impact: "Revenue Leakage",
      details: [
        "50-60% of patient balances remain uncollected",
        "Lack of transparent cost estimates upfront",
        "Limited payment options and plans",
        "Poor patient communication about balances"
      ]
    }
  ];

  const solutions = [
    {
      id: 1,
      title: "AI-Powered Claims Processing",
      icon: <Brain />,
      benefits: ["99.5% Accuracy", "80% Faster Processing", "50% Cost Reduction"],
      description: "Intelligent automation for end-to-end claims management",
      features: [
        "Automated coding with real-time validation",
        "Smart denial prediction and prevention",
        "Electronic claim submission with tracking",
        "Automated appeals and resubmission workflows"
      ]
    },
    {
      id: 2,
      title: "Real-Time Eligibility Verification",
      icon: <Target />,
      benefits: ["Instant Verification", "95% Denial Reduction", "Zero Wait Time"],
      description: "Automated insurance verification at every touchpoint",
      features: [
        "Real-time eligibility checks across all payers",
        "Automated benefit and coverage verification",
        "Pre-appointment verification workflows",
        "Integration with practice management systems"
      ]
    },
    {
      id: 3,
      title: "Intelligent Payment Collection",
      icon: <DollarSign />,
      benefits: ["70% Faster Collections", "40% Higher Recovery", "90% Patient Satisfaction"],
      description: "Automated payment processing and collection optimization",
      features: [
        "Multiple payment options including payment plans",
        "Automated payment reminders and follow-ups",
        "Transparent cost estimation before treatment",
        "Integration with popular payment platforms"
      ]
    },
    {
      id: 4,
      title: "Operational Workflow Automation",
      icon: <Zap />,
      benefits: ["85% Process Efficiency", "90% Schedule Optimization", "Seamless Integration"],
      description: "End-to-end workflow automation for dental practices",
      features: [
        "Intelligent appointment scheduling with optimization",
        "Automated patient communication and reminders",
        "Staff task automation and priority management",
        "Real-time analytics and performance insights"
      ]
    }
  ];

  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={styles.header}>
        <div style={styles.headerContent}>
          <h2 style={styles.mainTitle}>
            Medical Revenue Cycle Management Services for Dental Practices
          </h2>
          <p style={styles.subtitle}>
            Healthcare Revenue Cycle Management Services - AI-Powered Solutions
          </p>
          <p style={styles.description}>
            Eliminate operational bottlenecks with AI-powered automation from <a href="https://mdercm.com/" style={{ color: '#93c5fd', textDecoration: 'none', fontWeight: '600' }}>MDeRCM</a>. 
            Transform your dental practice's <strong>revenue cycle management</strong> with advanced Generative AI and Large Language Models. 
            As one of the <strong>best revenue cycle management companies</strong>, we provide comprehensive 
            <strong> medical billing outsourcing services</strong> with proven <strong>healthcare cost reduction strategies</strong>.
          </p>
          <p style={{
            color: '#93c5fd',
            maxWidth: '48rem',
            margin: '0 auto',
            lineHeight: '1.6',
            fontSize: '0.95rem'
          }}>
            Learn <strong>how to improve revenue cycle management</strong> with our expert <strong>revenue cycle management consulting services</strong>. 
            Join leading <strong>revenue cycle management services companies</strong> and discover why we're trusted for 
            <strong> outsourced revenue cycle management services</strong> across <strong>revenue cycle management services USA</strong>.
          </p>
        </div>
      </div>

      {/* Tab Navigation */}
      <div style={styles.tabNavigation}>
        <div style={styles.tabContainer}>
          <button
            onClick={() => setActiveTab('problems')}
            style={styles.tabButton(activeTab === 'problems')}
          >
            Current Challenges
          </button>
          <button
            onClick={() => setActiveTab('solutions')}
            style={styles.tabButton(activeTab === 'solutions')}
          >
            AI-Powered Solutions
          </button>
        </div>
      </div>

      {/* Content */}
      <div style={styles.mainContent}>
        {activeTab === 'problems' && (
          <div>
            <div style={styles.sectionHeader}>
              <h2 style={styles.sectionTitle}>
                Dental Practice Revenue Cycle Challenges
              </h2>
              <p style={styles.sectionSubtitle}>
                Identify and understand the critical bottlenecks affecting your dental practice's financial performance. 
                Our <strong>healthcare revenue cycle management services</strong> address these key challenges with proven 
                <strong> healthcare cost reduction strategies</strong>.
              </p>
            </div>

            <div style={styles.problemsGrid}>
              {dentalProblems.map((problem) => (
                <div key={problem.id} style={styles.card}>
                  <div
                    style={{
                      ...styles.cardHeader,
                      ...(expandedProblem === problem.id ? {} : {}),
                    }}
                    onClick={() => setExpandedProblem(expandedProblem === problem.id ? null : problem.id)}
                    onMouseEnter={(e) => {
                      if (expandedProblem !== problem.id) {
                        e.target.style.backgroundColor = styles.cardHeaderHover.backgroundColor;
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (expandedProblem !== problem.id) {
                        e.target.style.backgroundColor = 'transparent';
                      }
                    }}
                  >
                    <div style={styles.cardContent}>
                      <div style={styles.cardLeft}>
                        <div style={styles.iconContainer(problem.severity)}>
                          <div style={styles.icon(problem.severity)}>
                            <AlertTriangle />
                          </div>
                        </div>
                        <div style={styles.cardInfo}>
                          <h3 style={styles.cardTitle}>{problem.title}</h3>
                          <p style={styles.cardDescription}>{problem.description}</p>
                        </div>
                      </div>
                      <div style={styles.cardRight}>
                        <div>
                          <div style={styles.impactBadge(problem.severity)}>
                            {problem.impact}
                          </div>
                        </div>
                        <div style={styles.chevronContainer}>
                          {expandedProblem === problem.id ? (
                            <ChevronDown />
                          ) : (
                            <ChevronRight />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  {expandedProblem === problem.id && (
                    <div style={styles.expandedContent}>
                      <div style={styles.expandedContentInner}>
                        <h4 style={styles.expandedTitle}>Key Issues:</h4>
                        <ul style={styles.detailsList}>
                          {problem.details.map((detail, index) => (
                            <li key={index} style={styles.detailItem}>
                              <div style={styles.detailBullet}></div>
                              <span style={styles.detailText}>{detail}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>

            {/* SEO Content After Problems */}
            <div style={{
              marginTop: '3rem',
              padding: '2rem',
              background: 'white',
              borderRadius: '0.75rem',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)'
            }}>
              <p style={{
                fontSize: '15px',
                lineHeight: '1.8',
                color: '#555',
                textAlign: 'center'
              }}>
                Our <strong>revenue cycle management services for hospitals</strong> and dental practices provide solutions 
                to these challenges. With <strong>medical billing and coding outsourcing</strong> expertise and 
                <strong> hospital revenue cycle management</strong> experience, <a href="https://mdercm.com/" style={{ color: '#F26522', textDecoration: 'none', fontWeight: '600' }}>MDeRCM</a> delivers 
                comprehensive <strong>medical revenue cycle management services</strong> that transform your practice's financial performance.
              </p>
            </div>
          </div>
        )}

        {activeTab === 'solutions' && (
          <div>
            <div style={styles.sectionHeader}>
              <h2 style={styles.sectionTitle}>
                AI-Powered Revenue Cycle Solutions
              </h2>
              <p style={styles.sectionSubtitle}>
                Transform your dental practice with intelligent automation and seamless system integration. 
                Our <strong>outsourced revenue cycle management services</strong> combine AI technology with expert 
                <strong> revenue cycle management consulting services</strong> to deliver exceptional results.
              </p>
            </div>

            <div style={styles.solutionsGrid}>
              {solutions.map((solution) => (
                <div
                  key={solution.id}
                  style={styles.solutionCard}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1)';
                  }}
                >
                  <div
                    style={styles.solutionCardHeader}
                    onClick={() => setExpandedSolution(expandedSolution === solution.id ? null : solution.id)}
                  >
                    <div style={styles.solutionCardContent}>
                      <div style={styles.solutionLeft}>
                        <div style={styles.solutionIconContainer}>
                          <div style={styles.solutionIcon}>
                            {solution.icon}
                          </div>
                        </div>
                        <div style={styles.solutionInfo}>
                          <h3 style={styles.solutionTitle}>{solution.title}</h3>
                          <p style={styles.solutionDescription}>{solution.description}</p>
                          <div style={styles.benefitsContainer}>
                            {solution.benefits.map((benefit, index) => (
                              <span key={index} style={styles.benefitBadge}>
                                {benefit}
                              </span>
                            ))}
                          </div>
                        </div>
                      </div>
                      <div style={styles.chevronContainer}>
                        {expandedSolution === solution.id ? (
                          <ChevronDown />
                        ) : (
                          <ChevronRight />
                        )}
                      </div>
                    </div>
                  </div>

                  {expandedSolution === solution.id && (
                    <div style={styles.solutionExpandedContent}>
                      <div style={styles.solutionExpandedInner}>
                        <h4 style={styles.featuresTitle}>
                          <div style={styles.checkIcon}>
                            <CheckCircle />
                          </div>
                          Key Features:
                        </h4>
                        <div style={styles.featuresGrid}>
                          {solution.features.map((feature, index) => (
                            <div key={index} style={styles.featureItem}>
                              <div style={styles.featureBullet}></div>
                              <span style={styles.featureText}>{feature}</span>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>

            {/* SEO Content After Solutions */}
            <div style={{
              marginTop: '3rem',
              padding: '2.5rem',
              background: 'white',
              borderRadius: '0.75rem',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)'
            }}>
              <h3 style={{
                fontSize: '1.5rem',
                fontWeight: '700',
                color: '#111827',
                marginBottom: '1rem',
                textAlign: 'center'
              }}>
                Why Choose MDeRCM for Your Dental Practice?
              </h3>
              <p style={{
                fontSize: '15px',
                lineHeight: '1.8',
                color: '#555',
                textAlign: 'center',
                marginBottom: '1.5rem'
              }}>
                As specialists among <strong>medical billing outsourcing companies</strong>, we understand 
                <strong> how to improve revenue cycle management</strong> for dental practices. Our <strong>healthcare cost reduction consulting</strong> 
                approach delivers measurable results through advanced AI automation and expert support.
              </p>
              <p style={{
                fontSize: '15px',
                lineHeight: '1.8',
                color: '#555',
                textAlign: 'center'
              }}>
                Join dental practices across <strong>revenue cycle management services USA</strong> who trust <a href="https://mdercm.com/" style={{ color: '#F26522', textDecoration: 'none', fontWeight: '600' }}>MDeRCM</a> 
                as their partner for <strong>outsourced revenue cycle management services</strong>. Experience the difference that 
                one of the <strong>best revenue cycle management companies</strong> can make for your practice's financial health.
              </p>
            </div>

            {/* Related Services Links */}
            <div style={{
              marginTop: '2rem',
              padding: '2rem',
              background: 'linear-gradient(135deg, rgba(59, 130, 246, 0.05), rgba(139, 92, 246, 0.05))',
              borderRadius: '0.75rem',
              textAlign: 'center'
            }}>
              <h3 style={{
                fontSize: '1.25rem',
                fontWeight: '700',
                color: '#111827',
                marginBottom: '1rem'
              }}>
                Explore Our Complete Revenue Cycle Management Services
              </h3>
              <div style={{
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'center',
                gap: '1rem',
                marginTop: '1.5rem'
              }}>
                <Link
                  to="/healthcare/ai/accounts-receivable"
                  style={{
                    padding: '0.75rem 1.5rem',
                    background: 'white',
                    color: '#2563eb',
                    textDecoration: 'none',
                    borderRadius: '0.5rem',
                    fontWeight: '600',
                    fontSize: '0.95rem',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                    transition: 'all 0.3s ease'
                  }}
                >
                  AR Management
                </Link>
                <Link
                  to="/healthcare/ai/denial-management"
                  style={{
                    padding: '0.75rem 1.5rem',
                    background: 'white',
                    color: '#7c3aed',
                    textDecoration: 'none',
                    borderRadius: '0.5rem',
                    fontWeight: '600',
                    fontSize: '0.95rem',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                    transition: 'all 0.3s ease'
                  }}
                >
                  Denial Management
                </Link>
                <Link
                  to="/healthcare/ai/compliance-agent"
                  style={{
                    padding: '0.75rem 1.5rem',
                    background: 'white',
                    color: '#10b981',
                    textDecoration: 'none',
                    borderRadius: '0.5rem',
                    fontWeight: '600',
                    fontSize: '0.95rem',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                    transition: 'all 0.3s ease'
                  }}
                >
                  Compliance
                </Link>
                <Link
                  to="/healthcare/ai/payment-posting"
                  style={{
                    padding: '0.75rem 1.5rem',
                    background: 'white',
                    color: '#f97316',
                    textDecoration: 'none',
                    borderRadius: '0.5rem',
                    fontWeight: '600',
                    fontSize: '0.95rem',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                    transition: 'all 0.3s ease'
                  }}
                >
                  Payment Posting
                </Link>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MDeRCMDentalComponent;